import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserManage from './pages/UserManage';
import MessageManage from './pages/MessageManage';
import WechatConfig from './pages/WechatConfig';
import SMSConfig from './pages/SMSConfig';
import QiniuConfig from './pages/QiniuConfig';
import ApnsConfig from './pages/ApnsConfig';
import AndroidVersionConfig from './pages/AndroidVersionConfig';
import FeedbackManage from './pages/FeedbackManage';
import AgreementConfig from './pages/AgreementConfig';
import MainLayout from './layouts/MainLayout';

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem('admin_token');
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
};

const RedirectIfAuthenticated: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('admin_token');
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 6,
        },
      }}
    >
      <Router basename="/">
        <Routes>
          <Route
            path="/login"
            element={
              <RedirectIfAuthenticated>
                <Login />
              </RedirectIfAuthenticated>
            }
          />
          <Route
            path="/"
            element={
              <RequireAuth>
                <MainLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="users" element={<UserManage />} />
            <Route path="messages" element={<MessageManage />} />
            <Route path="feedbacks" element={<FeedbackManage />} />
            <Route path="settings/wechat" element={<WechatConfig />} />
            <Route path="settings/sms" element={<SMSConfig />} />
            <Route path="settings/qiniu" element={<QiniuConfig />} />
            <Route path="settings/apns" element={<ApnsConfig />} />
            <Route path="settings/android-version" element={<AndroidVersionConfig />} />
            <Route path="settings/agreement" element={<AgreementConfig />} />
          </Route>
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;
